export const BADGE_PHOTO_THUMBNAIL_URL =
  "https://internal-cdn.amazon.com/badgephotos.amazon.com/?uid=";
